/** Design-system button class recipes. Compose with layout/sizing overrides as needed. */
export const PRIMARY_BTN =
  "inline-flex min-h-11 items-center justify-center gap-2 rounded-md border border-spark-green-text bg-spark-green px-4 py-2 text-sm font-bold text-spark-ink shadow-[var(--shadow-input)] hover:bg-spark-green-hover transition-colors disabled:cursor-not-allowed disabled:opacity-50";

export const SECONDARY_BTN =
  "inline-flex min-h-11 items-center justify-center gap-2 rounded-md border border-spark-border bg-white px-3 py-1.5 text-sm font-semibold text-spark-charcoal hover:bg-spark-hover transition-colors disabled:cursor-not-allowed disabled:opacity-50";

export const DESTRUCTIVE_BTN =
  "inline-flex min-h-11 items-center justify-center gap-2 rounded-md border border-spark-red-text bg-white px-4 py-2 text-sm font-semibold text-spark-red-text hover:bg-spark-red-tint/50 transition-colors disabled:cursor-not-allowed disabled:opacity-50";

/** DESTRUCTIVE_BTN sized for table rows and compact toolbars */
export const DESTRUCTIVE_BTN_SM =
  "inline-flex min-h-9 items-center justify-center gap-2 rounded-md border border-spark-red-text bg-white px-3 py-1.5 text-xs font-semibold text-spark-red-text hover:bg-spark-red-tint/50 transition-colors disabled:cursor-not-allowed disabled:opacity-50";

/** PRIMARY_BTN sized for compact toolbars/card headers */
export const PRIMARY_BTN_SM =
  "inline-flex min-h-9 items-center justify-center gap-2 rounded-md border border-spark-green-text bg-spark-green px-3 py-1.5 text-xs font-bold text-spark-ink shadow-[var(--shadow-input)] hover:bg-spark-green-hover transition-colors disabled:cursor-not-allowed disabled:opacity-50";

/** Compact secondary button for tight card headers */
export const SECONDARY_BTN_SM =
  "inline-flex min-h-9 items-center justify-center gap-2 rounded-md border border-spark-border bg-white px-3 py-1.5 text-xs font-semibold text-spark-charcoal hover:bg-spark-hover transition-colors disabled:cursor-not-allowed disabled:opacity-50";

/** AI action button: blue fill reserved for Claude-powered actions. White on
 *  #1D5FD6 (the spark-action-blue token) is AA; pair with AIIcon (ui/ai-icon). */
export const AI_BTN =
  "inline-flex min-h-11 items-center justify-center gap-2 rounded-md bg-spark-action-blue px-4 py-2 text-sm font-bold text-white shadow-[0_3px_10px_-2px_rgba(46,125,247,.45)] hover:bg-spark-ai-hover transition-colors disabled:cursor-not-allowed disabled:opacity-50";

/** AI_BTN sized for compact toolbars/card headers */
export const AI_BTN_SM =
  "inline-flex min-h-9 items-center justify-center gap-2 rounded-md bg-spark-action-blue px-3 py-1.5 text-xs font-bold text-white shadow-[0_3px_10px_-2px_rgba(46,125,247,.45)] hover:bg-spark-ai-hover transition-colors disabled:cursor-not-allowed disabled:opacity-50";

export const LINK_CLASS = "text-spark-blue-text font-semibold hover:underline";

/** Variant → class map shared by SubmitButton and AsyncButton */
export const BUTTON_VARIANT_CLASSES = {
  primary: PRIMARY_BTN,
  secondary: SECONDARY_BTN,
  destructive: DESTRUCTIVE_BTN,
  link: `text-xs ${LINK_CLASS} disabled:text-spark-gray disabled:no-underline focus-visible:ring-2 focus-visible:ring-spark-blue focus-visible:ring-offset-1 focus-visible:outline-none rounded`,
} as const;
